/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:data
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/21 | 富士通株式会社        | 新規作成
//================================================================================
 */
// 画面データ
export const data = {
	namespaced: true,
	state: {
		dataArray: [{}]
	},
	getters: {
		// 画面IDごとにデータObjectを保持します
		getData(state) { return function (id) {
				for ( var i = 0; i < state.dataArray.length; i++ ) {
					if ( state.dataArray[i].id === id ) {
						return JSON.parse(JSON.stringify(state.dataArray[i].data));
					}
				}
				return null;
			}
		}
	},
	mutations: {
		// 全てのデータを削除
		deleteAll(state) {
			state.dataArray.splice(0);
		},
		// 指定された画面IDのデータを削除
		deleteAt(state, id) {
			for ( var i = 0; i < state.dataArray.length; i++ ) {
				if ( state.dataArray[i].id === id ) {
					state.dataArray.splice(i, 1);
				}
			}
		},
		// データを保持
		addData(state, {id, data}) {
			var hasData = false;
			let clone = JSON.parse(JSON.stringify(data));

			for ( var i = 0; i < state.dataArray.length; i++ ) {
				if ( state.dataArray[i].id === id ) {
					state.dataArray[i].data = clone;
					hasData = true;
				}
			}
			if ( !hasData ) {
				state.dataArray.push({id:id, data:clone});
			}
		}
	},
	actions: {
	},
	modules: {
	}
}